var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinearCheckboxShowMore = function SvgLinearCheckboxShowMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 7094",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.56,
    height: 23.559
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 193",
    fill: "none",
    d: "M0 0h23.559v23.559H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4141",
    transform: "translate(3.927 3.927)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 194",
    width: 15.706,
    height: 15.706,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 39",
    d: "M7.853 3.927v7.853"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 40",
    d: "M11.78 7.853H3.927"
  }))));
};
export { SvgLinearCheckboxShowMore as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iR3JvdXBfNzA5NCIgZGF0YS1uYW1lPSJHcm91cCA3MDk0IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMy41NiIgaGVpZ2h0PSIyMy41NTkiIHZpZXdCb3g9IjAgMCAyMy41NiAyMy41NTkiPgogIDxyZWN0IGlkPSJSZWN0YW5nbGVfMTkzIiBkYXRhLW5hbWU9IlJlY3RhbmdsZSAxOTMiIHdpZHRoPSIyMy41NTkiIGhlaWdodD0iMjMuNTU5IiBmaWxsPSJub25lIi8+CiAgPGcgaWQ9Ikdyb3VwXzQxNDEiIGRhdGEtbmFtZT0iR3JvdXAgNDE0MSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMy45MjcgMy45MjcpIj4KICAgIDxyZWN0IGlkPSJSZWN0YW5nbGVfMTk0IiBkYXRhLW5hbWU9IlJlY3RhbmdsZSAxOTQiIHdpZHRoPSIxNS43MDYiIGhlaWdodD0iMTUuNzA2IiByeD0iMiIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KICAgIDxsaW5lIGlkPSJMaW5lXzM5IiBkYXRhLW5hbWU9IkxpbmUgMzkiIHkyPSI3Ljg1MyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNy44NTMgMy45MjcpIiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjEuNSIvPgogICAgPGxpbmUgaWQ9IkxpbmVfNDAiIGRhdGEtbmFtZT0iTGluZSA0MCIgeDE9IjcuODUzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzLjkyNyA3Ljg1MykiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41Ii8+CiAgPC9nPgo8L3N2Zz4K";